
// date
interface Date {
  ToShortDateString(): string;
}

Date.prototype.ToShortDateString = function (): string {
  const dia = this.getDate();
  const mes = this.getMonth() + 1;
  const ano = this.getFullYear();
  return dia + '/' + mes + '/' + ano;
};

// string
interface String {
  ToDate(): Date;
  IsNullOrEmpty(): boolean;
}

String.prototype.IsNullOrEmpty = function (): boolean {
  if (this === undefined || this === null || this.trim() === '') {
    return true;
  }
  return false;
};

String.prototype.ToDate = function (): Date {
  if (!this.IsNullOrEmpty()) {
    const data = this.split('/');
    if (data.length === 3) {
      const dt = new Date();
      dt.setDate(parseInt(data[0], 10));
      dt.setMonth(parseInt(data[1], 10) - 1);
      dt.setFullYear(parseInt(data[2], 10));

      return dt;
    }
  }
  return null;
};
